module.exports = __webpack_public_path__ + "./fonts/icomoon.308f0dc51539023941b164b77ec0646f.ttf";